<template>
  <section class="trainings">
    <div class="trainings__banner">
      <TopBanner class="mb-16" :item="banner" />
    </div>
    <div class="container _py-16 _py-md-12">
      <AppBtnBreadCrumb class="_mb-4 _ml-md-4" />
      <QualificationFilter class="_px-md-4" />
      <div class="sections__list d-grid row-1-1 gap-32">
        <SectionCard
          v-for="(block, ind) in blocks"
          :key="ind + 100"
          :item="block"
          @click.native="checkAccess(block)"
          class="_px-md-0 _px-sm-0"
        >
          <template v-slot:image>
            <img :src="block.image" alt="" />
          </template>
          <template v-slot:button>
            <AppBtn class="_mt-4 _ml-md-4">
              <span class="_py-4 _px-6 _fs-16 _tc-white">
                {{ $t("interface.video.watch") }}
              </span>
            </AppBtn>
          </template>
        </SectionCard>
        <VideoCard
          @like="like"
          @favorite="favorite"
          @downloadFile="downloadFile"
          @viewItem="viewItem"
          @setVideoProgress="setVideoProgress"
          v-for="(block, ind) in getTrainingsListAll"
          :key="ind"
          :item="getTranslate(block)"
          :analyticEventPrefix="'trainings_material'"
        ></VideoCard>
      </div>
    </div>
    <Modal v-if="accessDenied" @close="modalToggle('accessDenied', false)">
      <template v-slot:modalBody>
        <div
          class="modal__content d-flex justify-center align-center direction-column"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
          >
            <path
              d="M43.6667 30.3335H20.3333C18.4924 30.3335 17 31.8259 17 33.6668V45.3335C17 47.1744 18.4924 48.6668 20.3333 48.6668H43.6667C45.5076 48.6668 47 47.1744 47 45.3335V33.6668C47 31.8259 45.5076 30.3335 43.6667 30.3335Z"
              stroke="#77BB2F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.6665 30.3335V23.6668C23.6665 21.4567 24.5445 19.3371 26.1073 17.7743C27.6701 16.2115 29.7897 15.3335 31.9998 15.3335C34.21 15.3335 36.3296 16.2115 37.8924 17.7743C39.4552 19.3371 40.3332 21.4567 40.3332 23.6668V30.3335"
              stroke="#77BB2F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <h2
            class="_fs-24 _lh-32 _tc-dark _mt-4 _fw-700"
            style="text-align: center"
          >
            {{ $t("pages.trainings.access_denied") }}
          </h2>
        </div>
      </template>
    </Modal>
    <div class="_bg-light">
      <OtherMain :items="sectionsList" :analyticEventPrefix="'trainings_'">
        <template v-slot:title>
          <div
            class="section-detail__title _fs-32 _lh-38 _fs-sm-24 _lh-sm-32 _fw-600"
          >
            {{ $t("another_sections_title") }}
          </div>
        </template>
      </OtherMain>
    </div>
  </section>
</template>

<script>
import Modal from "@/components/UI/Modal";
import TopBanner from "@/components/UI/banners/TopBanner";
import SectionCard from "@/components/UI/cards/SectionCard";
import VideoCard from "@/components/UI/cards/VideoCard";
import OtherMain from "@/components/UI/OtherMain";
import AppBtn from "@/components/UI/buttons/AppBtn";
import toPage from "@/mixins/toPage";
import AppBtnBreadCrumb from "@/components/UI/buttons/AppBtnBreadCrumb";
import QualificationFilter from "@/components/UI/QualificationFilter";
import download from "@/mixins/download";
import { bus } from "@/main";

import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo() {
    return { title: this.$t("interface.menu.trainings") };
  },
  name: "TrainingsMain",
  mixins: [download, toPage],
  components: {
    TopBanner,
    SectionCard,
    VideoCard,
    OtherMain,
    AppBtnBreadCrumb,
    QualificationFilter,
    Modal,
    AppBtn,
  },
  data: () => ({
    accessDenied: false,
    secondName: "",
  }),
  computed: {
    ...mapGetters(["getTrainingsListExclusive", "getTrainingsListAll"]),
    sectionsList() {
      const vm = this;
      return this.$t("another_sections") &&
        Array.isArray(this.$t("another_sections"))
        ? this.$t("another_sections")
            .filter((el) => !el.hide)
            .map(function (el) {
              return {
                ...el,
                image: require(`@/assets/img/sections/${el.image}`),
                route: vm.helpers.buildRoute(el.route),
              };
            })
        : null;
    },
    currentLocale() {
      return this.Trans.currentLocale;
    },
    banner() {
      return {
        title: this.$t("pages.trainings.title"),
        descr: this.$t("pages.trainings.description"),
        theme: "dark",
        images: [
          {
            src: require("@/assets/img/banners/trainings/TR-mob.jpg"),
            media: "(max-width: 743px)",
          },
          {
            src: require("@/assets/img/banners/trainings/TR-tab.jpg"),
            media: "(max-width: 1220px)",
          },
          {
            src: require("@/assets/img/banners/trainings/TR-1440.jpg"),
            media: "(max-width: 1919px)",
          },
          {
            src: require("@/assets/img/banners/trainings/TR-1920.jpg"),
            media: "(min-width: 1920px)",
          },
        ],
      };
    },
    blocks() {
      return [
        {
          title: this.$t("pages.trainings.block.title"),
          description: this.$t("pages.trainings.block.description"),
          image: require(`@/assets/img/blocks/trainings/block-1.jpg`),
          access_groups: "school_2500",
          page: "Qualification",
        },
        // {
        //   title: 'Новый раздел',
        //   description: this.$t('pages.trainings.block.description'),
        //   image: require(`@/assets/img/blocks/trainings/block-1.jpg`),
        //   access_groups: 'tab-test',
        //   page: 'Qualification2',
        // },
      ];
    },
  },
  methods: {
    ...mapActions([
      "fetchTrainingsList",
      "TrainingsSetVideoProgress",
      "TrainingsSetLike",
      "TrainingsSetFavorite",
      "TrainingsSetView",
      "SOCKET_SEND_MESSAGE",
    ]),
    checkAccess(block) {
      if (
        this.getTrainingsListExclusive &&
        this.getTrainingsListExclusive.length &&
        this.getTrainingsListExclusive.filter((el) =>
          el.access_groups.includes(block.access_groups)
        ).length
      ) {
        this.toPage({ name: block.page });
      } else {
        this.accessDenied = true;
      }
      if (this.$gtm) {
        this.$gtm.push({
          event: "trainings_block",
          param_value: this.helpers.stripHtml(block.title),
        });
      }
    },
    modalToggle(model, state) {
      this[model] = state;
      bus.$emit("scrollLock", state);
    },
    getTranslate(item) {
      return {
        ...item,
        title: item.translates[0].title,
        description: item.translates[0].description,
        preview: item.translates[0].preview,
        file: item.translates[0].file || item.translates[0].file_link,
        file_size: item.translates[0].file_size,
        extras: item.translates[0].extras,
        date: `${this.$t(
          `interface.months[${new Date(item.created_at).getMonth()}]`
        )} ${new Date(item.created_at).getFullYear()}`,
      };
    },
    async updateList() {
      await this.fetchTrainingsList({
        lang: this.currentLocale,
      });
    },
    async like(id) {
      await this.TrainingsSetLike(id);
      await this.updateList();
    },
    async favorite(id) {
      await this.TrainingsSetFavorite(id);
      await this.updateList();
    },
    async setVideoProgress(id, time) {
      await this.TrainingsSetVideoProgress({
        id: id,
        progress: Math.round(time),
      });
      await this.updateList();
    },
    async viewItem(id) {
      await this.TrainingsSetView({ id: id });
      await this.updateList();
    },
  },
  async mounted() {
    await this.fetchTrainingsList({
      lang: this.currentLocale,
    });
    this.SOCKET_SEND_MESSAGE(
      JSON.stringify({
        action: "set_path",
        path: this.$router.resolve({
          name: this.$route.name.replace("Loc", ""),
        }).href,
      })
    );
    // await this.fetchTrainingsList({ lang: this.currentLocale, access: true })
  },
  async created() {
    await this.fetchTrainingsList({ lang: this.currentLocale, access: true });
  },
};
</script>

<style lang="scss" scoped>
.trainings {
  &__banner {
    background-color: #EBF6E3;
  }

  .top-banner {
    max-width: 1920px;
    margin: 0 auto;
  }
}
</style>

<style lang="scss">
.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}
</style>

<style lang="scss">
.selectaria {
  width: 100%;
  &__label {
    margin-bottom: 16px;
    font-family: "Helvetica Neue", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #1f1f1f;
  }

  &__select {
    padding: 0 16px;
    width: 100%;
    height: 56px;
    max-width: 384px;
    border: 1px solid #d4d4d4;
    border-radius: 5px;
    font-family: "Helvetica Neue", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #707372;
    background-color: #fff;
    display: block;
    transition: 0.3s;
    .vs__dropdown-menu {
      -ms-overflow-style: scrollbar;
      scrollbar-color: #b2b4b2 transparent;
      scrollbar-width: thin;
      scroll-margin-right: 4px;

      &::-webkit-scrollbar {
        width: 5px;
        height: 8px;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #77bb2f;
        border-radius: 5px;
        height: 8px;
      }

      &::-webkit-scrollbar--track-piece {
        border-radius: 5px;
        background-color: #ebefee;
      }

      &::-webkit-scrollbar-track {
        border-radius: 5px;
        background-color: #ebefee;
        border: 3px solid #fff;
      }

      &::-moz-scrollbar-button:decrement,
      &::-moz-scrollbar-button:increment,
      &::-moz-scrollbar-button:vertical:start:decrement,
      &::-moz-scrollbar-button:vertical:end:increment,
      &::-moz-scrollbar-button:horizontal:start:decrement,
      &::-moz-scrollbar-button:horizontal:end:increment,
      &::-webkit-scrollbar-button:vertical:start:decrement,
      &::-webkit-scrollbar-button:vertical:end:increment,
      &::-webkit-scrollbar-button:horizontal:start:decrement,
      &::-webkit-scrollbar-button:horizontal:end:increment {
        width: 0px !important;
        height: 0px !important;
      }
    }
    .vs__dropdown-toggle {
      height: 100%;
      border: none;
      padding: 0;
      .vs__search::placeholder {
        font-family: "Helvetica Neue", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 21px;
        color: #707372;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .vs__search:placeholder-shown {
        text-overflow: ellipsis;
      }
      .vs__search,
      .vs__search:focus {
        margin: 0;
        padding: 0;
        overflow: hidden;
      }
      .vs__clear {
        display: none;
      }

      .vs__selected {
        margin: 0;
        position: static;
        opacity: 1;
      }
    }

    .vs__dropdown-option {
      margin: 12px 0;
      white-space: inherit;
      font-family: "Inter", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #b2b4b2;
    }
  }
  &__error {
    margin-top: 8px;
    font-family: "Helvetica Neue", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #cb4050;
  }
  &_error {
    & .selectaria__select {
      border-color: #cb4050;
      background-color: #faebed;
    }
  }
}

.placeholder-immitation {
  position: static;
  font-family: "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #707372;
  display: flex;
  align-items: center;
  &:first-child {
    padding: 0 5px;
    position: absolute;
    background-color: #fff;
    top: -10px;
    left: -2px;
    display: flex;
    align-items: center;
    line-height: 1.4;
    font-size: 1em;
    font-family: "Helvetica Neue", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    color: #707372;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: 0.3s;
  }
}

.vs__dropdown-option--selected {
  color: #77bb2f !important;
}

.vs__dropdown-option--deselect {
  background: none;
  color: inherit;
}

.vs__dropdown-option--highlight {
  background: none;
  color: inherit;
}

.vs__dropdown-option:hover {
  background: #77bb2f;
  color: #fff !important;
}
</style>
<style>
.vs__dropdown-option:hover .checkbox__label {
  color: #fff !important;
}
</style>
